import { Component, computed, input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { pxToRem } from '@pc/shared';

@Component({
  selector: 'pc-separator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './separator.component.html',
  styleUrl: './separator.component.scss'
})
export class SeparatorComponent {
  public pxToRem = pxToRem;
  public verticalHeight = input<number>(0);
  public separatorClass: Signal<Record<string, boolean>> = computed(() => ({
    separator: true,
    vertical: this.verticalHeight() !== 0,
    horizontal: this.verticalHeight() === 0
  }));
  public separatorStyle: Signal<Record<string, string>> = computed(() => ({
    height: this.pxToRem(this.verticalHeight() || 1) + 'rem'
  }));
}
